import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product, ProductInventory } from './products.service';
import { catchError, Observable, throwError } from 'rxjs';
import { GroupedOrder } from 'src/app/domain/grouped-order';

@Injectable({
  providedIn: 'root'
})
export class ProductInventoryService {
  
   PATH = "/appliances/api/v2/product-inventory";

  constructor(private httpClient: HttpClient) { }

  getProductInventory(): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<ProductInventory[]>(this.PATH  , {headers})
      .pipe(catchError(this.errorHandler));
  }
  getCustomerOrderCounts(): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<any[]>("/appliances/api/v2/customer/order-count" , {headers})
      .pipe(catchError(this.errorHandler));
  }

  getCustomerGroups(): Observable<GroupedOrder[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<GroupedOrder[]>("/appliances/api/v2/customer/group" , {headers})
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }

}
